module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/reports/leave/Table.ejs -->\n';
  if (!isFinished) { 
__p+='\n    <h3>\n        Loading employee leave balances...\n    </h3>\n';
 } else if (isFinished && (leaveTableRows.length || 0) === 0) { 
__p+='\n    <h3>\n        No records available.\n    </h3>\n';
 } else { 
__p+='\n    <table class="leave-table table table-striped"\n        data-paging="true" data-page-size="25" data-sorting="false">\n\n        <thead>\n            <tr class="first-header">\n                <th style="width: 25%;">Employee</th>\n                <th data-type="numeric">Days Entitled</th>\n                <th data-type="numeric">Days Allowed</th>\n                <th data-type="numeric">Days Taken</th>\n                <th data-type="numeric">Days Carried Forward</th>\n                <th data-type="numeric">Days Remaining</th>\n            </tr>\n        </thead>\n\n        <tbody class="js-rows">\n            ';
 leaveTableRows.forEach(function (row) { 
__p+='\n                <tr>\n                    <td>'+
((__t=( row.fullName ))==null?'':_.escape(__t))+
'</td>\n                    <td>'+
((__t=( row.daysEntitled ))==null?'':_.escape(__t))+
'</td>\n                    <td>'+
((__t=( row.daysAllowed ))==null?'':_.escape(__t))+
'</td>\n                    <td>'+
((__t=( row.daysTaken ))==null?'':_.escape(__t))+
'</td>\n                    <td>'+
((__t=( row.daysCarryForward ))==null?'':_.escape(__t))+
'</td>\n                    <td>'+
((__t=( row.daysRemaining ))==null?'':_.escape(__t))+
'</td>\n                    <td>\n                        <a href="#" style="color: #00b800"\n                            class="js-details" data-employee-id="'+
((__t=( row.employeeId ))==null?'':_.escape(__t))+
'">\n\n                            <i class="fa fa-bar-chart"></i> View Details\n                        </a>\n                    </td>\n                </tr>\n            ';
 }); 
__p+='\n        </tbody>\n\n        <tfoot>\n            <tr>\n                <td colspan="7">\n                    <ul class="pagination pull-right"></ul>\n                    <<button class="btn btn-outline pull-right btn-success js-send-leave-report">\n                        <i class="fa fa-envelope-o"></i>\n                        Send Leave Report\n                    </button>\n                </td>\n            </tr>\n        </tfoot>\n    </table>\n';
 } 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/reports/leave/Table.ejs
// module id = 830
// module chunks = 1